import React from 'react';
import PropTypes from 'prop-types';
import { imageSet } from '../../../helper/Images';
const Choice = ({ option, questionNo, value, handleChange }) => {
  return (
    <label className="option-item">
      <div className="option-item--labels">
        <div className="items-top">
          <img
            src={imageSet[option.key]}
            className={`img-responsive option-img option-img--${questionNo}`}
            alt=""
          />
          <div className="option-label" dangerouslySetInnerHTML={{ __html: option.label }}/>
        </div>
        <input
          type="radio"
          name={`q${questionNo}`}
          value={value}
          onChange={handleChange}
        />
      </div>
    </label>
  );
};
Choice.propTypes = {
  option: PropTypes.shape({
    key: PropTypes.string,
    label: PropTypes.string,
  }).isRequired,
  questionNo: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
  handleChange: PropTypes.func.isRequired,
};
export default Choice;
